import { ColorInput } from "../../../views/attributeeditorview";
import { Attribute } from "../../lib/attributes";
import { RegisterWidget, Widget } from "../../lib/widget";
import template from './loader.html';

@RegisterWidget({tag: 'se-loader', displayName: 'Loader', template: template, section: 'Input'})
export class Loader extends Widget {
    onchange: ()=>void = ()=>{};
    @Attribute({
        displayName: 'Background Color',
        getInput: (name, parent, property, getValue, onSettingChangedCallback, tooltip) => {
            return new ColorInput(name, parent, property, getValue, onSettingChangedCallback, tooltip);
        }}
    ) onColor: string = '#2196F3';
    @Attribute({
        displayName: 'Background Color',
        getInput: (name, parent, property, getValue, onSettingChangedCallback, tooltip) => {
            return new ColorInput(name, parent, property, getValue, onSettingChangedCallback, tooltip);
        }}
    ) offColor: string = '#ffffff';
    @Attribute({displayName: 'Disabled'}) disabled : boolean = false;
}